import React from "react";
import SEO from "../components/SEO";
function PrivacyPolicy({ isDarkMode }) {
  const embedCode = `
        <iframe src="https://docs.google.com/document/d/e/2PACX-1vQp302EHsB4NyEzBmfHC2hpFlGXzUsOcwHzDhFl3MPlFSnXgCYQbX9riirembozRtfFMr6lXfPCuqhX/pub?embedded=true" width="100%" height="900"  allow="autoplay"></iframe>
      `; // Replace YOUR_EMBED_URL_HERE with the actual URL from the embed code

  return (
    <div className="flex justify-center min-h-screen mt-32">
      <SEO
        title="Privacy Policy | Sustally"
        description="Read how Sustally Technologies Pvt. Ltd. collects, uses, and protects personal information when you use the Sustally app or website."
        url="/privacy-policy"
      />
      {/* <div className="privacy-policy w-[95%] lg:w-[60%]">
        <div className="p-0" dangerouslySetInnerHTML={{ __html: embedCode }} />
      </div> */}
      <div className="max-w-4xl p-6 mx-auto space-y-4 leading-relaxed privacy-policy-content">
        <h1>Privacy Policy</h1>
        <p>
          <strong>Last updated:</strong> Oct, 2025
        </p>

        <h2>1. General</h2>
        <p>
          1.1 Sustally Technologies Pvt. Ltd. (“Sustally”, “We”, “Our”, “Us”) is
          committed to the protection of user (“You”, “Your”, “User”) provided
          information which personally identifies You (“Personal Information”).
          You agree that Your use of Sustally’s mobile application (“App”) or
          product (“Web”) implies Your consent to collecting, receiving,
          possessing, storing, dealing or handling of Your Personal Information
          in accordance with this Privacy Policy.
        </p>

        <p>
          1.2 This Privacy Policy applies to all Users who access the App/Web
          and are therefore required to read and understand the Privacy Policy
          before submitting any Personal Information.
        </p>

        <p>
          1.3 We take the privacy of our Users seriously and are committed to
          safeguarding the privacy of Our Users while providing a personalized
          and valuable service.
        </p>

        <p>
          1.4 Access to the contents available through the App/Web is
          conditional upon Your approval of this Privacy Policy in addition to
          the Terms and Conditions of use.
        </p>

        <h2>2. Information Collected</h2>

        <h3>2.1 Traffic Data Collected</h3>
        <ul>
          <li>IP addresses</li>
          <li>Domain servers</li>
          <li>
            Device interaction and application usage data (“Traffic Data”)
          </li>
        </ul>

        <h3>2.2 Personal Information Collected</h3>
        <ul>
          <li>Contact data (email, phone number, contacts)</li>
          <li>Device data</li>
          <li>Demographic data (time zone, postal address, location)</li>
        </ul>

        <p>
          If You communicate with Us by email or letter, such information may be
          collected and stored by Sustally. Personal Information may be
          transmitted to internal servers outside India and is deleted 180 days
          after account termination unless required by law.
        </p>

        <h3>2.3 Third Party Links</h3>
        <p>
          Our App/Web may contain links to third-party websites. Sustally is not
          responsible for their privacy practices. Users are encouraged to read
          third-party privacy policies.
        </p>

        <h2>3. Usage of Personal Information</h2>
        <ul>
          <li>Building marketing profiles</li>
          <li>Business analytics and strategic development</li>
          <li>Managing relationships with advertisers and partners</li>
          <li>Providing technological services</li>
          <li>Auditing usage</li>
          <li>Enhancing user experience</li>
        </ul>

        <h2>4. Disclosure of Personal Information</h2>
        <p>
          Sustally does not sell or rent User information. Information may be
          shared with affiliates, service providers, or legal authorities when
          required by law.
        </p>

        <h2>5. Security</h2>
        <p>
          We use commercially reasonable security measures to protect Personal
          Information. However, no system is completely secure. If a breach
          occurs, we will notify users as required by law.
        </p>

        <h2>6. Updates to Privacy Policy</h2>
        <p>
          Sustally reserves the right to update this Privacy Policy at any time.
          Continued use of services constitutes acceptance of the changes.
        </p>

        <h2>7. Your Rights</h2>
        <ul>
          <li>You may review and correct your Personal Information</li>
          <li>You may request deletion of your Personal Information</li>
        </ul>

        <h2>8. Restriction of Liability</h2>
        <p>
          Sustally disclaims liability for errors, omissions, and damages
          arising from use of the App/Web.
        </p>

        <p>
          If you have questions, contact us at{" "}
          <a
            className="!text-sustally-violet"
            href="mailto:support@sustally.com"
          >
            support@sustally.com
          </a>
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
